import React from "react";
import * as CHQ from "chq";

import { Trans } from "app/utils";
import { useProfile } from "app/context";
import { StoryLink } from "app/links";

import BodyTags from "components/common/BodyTags";
import LazyEditorOutput from "components/editor/LazyEditorOutput";

import NotificationBody from "./NotificationBody";

type VideoMontageDoneNotificationProps = {
  notification: CHQ.NotificationVideoMontageDone;
  tabIndex?: number;
};

const VideoMontageDoneNotification: React.FC<VideoMontageDoneNotificationProps> = ({
  notification: { entity }, tabIndex
}) => {
  const { profile } = useProfile();

  return (
    <NotificationBody actor={entity?.creator || profile}>
      Your
      {" "}
      <Trans>
        {entity ? (
          <StoryLink story={entity} tabIndex={tabIndex || 0}>
            video montage
          </StoryLink>
        ) : (
          <Trans>video montage</Trans>
        )}
        {" "}
        was created successfully
      </Trans>
      <br />
      <LazyEditorOutput output={entity?.body} showTags={false} tabIndex={tabIndex} />
      <BodyTags tags={entity?.bodyTags} />
    </NotificationBody>
  );
};

export default VideoMontageDoneNotification;
